import classes from "./styles.module.scss";
import clsx from "classnames";
import { Carousel, Container } from "react-bootstrap";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { PromotionalCarouselItem } from "@/ui";

export const PromotionalCarousel = ({ className, items, bgColor, textColor }) => {
  return (
    <div className={clsx(className, bgColor, textColor, classes.PromotionalCarousel)}>
      <Container className="mw-xxl">
        <Carousel
          className={clsx(className, classes.PromotionalCarousel__carousel)}
          controls={true}
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
          indicators={false}
        >
          {items.map(({ title, description, img, video_embed_url, button }, k) => (
            <Carousel.Item key={k}>
              <PromotionalCarouselItem
                title={title}
                description={description}
                img={img?.url}
                video_embed_url={video_embed_url}
                cta={
                  Array.isArray(button)
                    ? button[0]
                      ? { ...button[0], target: button[0].open_in_new_tab ? "_blank" : undefined }
                      : undefined
                    : button
                    ? { ...button, target: button.open_in_new_tab ? "_blank" : undefined }
                    : undefined
                }                
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
};

export default PromotionalCarousel;
